import { Passenger } from './train-order'

/**
 * 火车票改签单类
 */
export default class TrainChangeOrder {
  constructor(order = {}) {
    this.id = order.changeId
    this.appId = order.appId // (string, optional): 审批规则id ,
    this.applyDate = order.applyDate // (string): 申请日期 ,
    this.applyDeptName = order.applyDeptName // (string): 申请部门名称 ,
    this.applyUserName = order.applyUserName // (string): 申请人名称 ,
    this.buyChangePoundage = order.buyChangePoundage // (number): 改签手续费 ,
    this.buyServiceCharge = order.buyServiceCharge // (number): 改签服务费 ,
    this.changeAmount = order.changeAmount // (string): 改签总金额 ,
    this.changeId = order.changeId // (string): 订单id ,
    this.changeNo = order.changeNo // (string): 改签单编号 ,
    this.changeReasonVip = order.changeReasonVip // (string): 改签原因 ,
    this.changeStatus = order.changeStatus // (string): 改签状态 ,
    this.changeStatusName = order.changeStatusName // (string): 改签状态名称 ,
    this.completeDate = order.completeDate // (string): 完成时间 ,
    this.completeDeptName = order.completeDeptName // (string): 完成部门名称 ,
    this.completeUserName = order.completeUserName // (string): 完成人名称 ,
    this.newFromCityName = order.newFromCityName // (string): 新出发城市名称 ,
    this.newFromDate = order.newFromDate // (string): 新出发日期 ,
    this.newFromStationName = order.newFromStationName // (string): 新出发站名称 ,
    this.newFromStationCode = order.newFromStationCode // (string): 新出发站三字码 ,
    this.newFromTime = order.newFromTime // (string): 新出发时刻 ,
    this.newFromWeek = order.newFromWeek // (string): 新出发星期 ,
    this.newSeatType = order.newSeatType // (string): 新座位席别 ,
    this.newSeatTypeName = order.newSeatTypeName // (string): 新座位席别名称 ,
    this.newTicketPrice = order.newTicketPrice // (number): 新票价 ,
    this.newToCityName = order.newToCityName // (string): 新到达城市名称 ,
    this.newToDate = order.newToDate // (string): 新到达日期 ,
    this.newToStationName = order.newToStationName // (string): 新到达站名称 ,
    this.newToStationCode = order.newToStationCode // (string): 新到达站三字码 ,
    this.newToTime = order.newToTime // (string): 新到达时刻 ,
    this.newTrainCode = order.newTrainCode // (string): 列车编号(新) ,
    this.newTrainNo = order.newTrainNo // (string): 新车次 ,
    this.newTravelTime = order.newTravelTime // (integer): 新旅行时长 ,
    this.newTravelTimeStr = order.newTravelTimeStr // (string): 新旅行时长中文 ,
    this.oldFromCityName = order.oldFromCityName // (string): 旧出发城市名称 ,
    this.oldFromDate = order.oldFromDate // (string): 旧出发日期 ,
    this.oldFromStationName = order.oldFromStationName // (string): 旧出发站名称 ,
    this.oldFromStationCode = order.oldFromStationCode // (string): 旧出发站三字码 ,
    this.oldFromTime = order.oldFromTime // (string): 旧出发时刻 ,
    this.oldFromWeek = order.oldFromWeek // (string): 旧出发星期 ,
    this.oldSeatType = order.oldSeatType // (string): 旧座位席别 ,
    this.oldSeatTypeName = order.oldSeatTypeName // (string): 旧座位席别名称 ,
    this.oldTicketPrice = order.oldTicketPrice // (number): 旧票价 ,
    this.oldToCityName = order.oldToCityName // (string): 旧到达城市名称 ,
    this.oldToDate = order.oldToDate // (string): 旧出发日期 ,
    this.oldToStationName = order.oldToStationName // (string): 旧到达站名称 ,
    this.oldToStationCode = order.oldToStationCode // (string): 旧到达站三字码 ,
    this.oldToTime = order.oldToTime // (string): 旧出发时刻 ,
    this.oldTrainCode = order.oldTrainCode // (string): 旧车次 ,
    this.oldTrainNo = order.oldTrainNo // (string): 原列车编号 ,
    this.oldTravelTime = order.oldTravelTime // (integer): 旧旅行时长 ,
    this.oldTravelTimeStr = order.oldTravelTimeStr // (string): 旧旅行时长中文 ,
    this.orderId = order.orderId // (string): 原订单id ,
    this.orderNo = order.orderNo // (string): 原订单编号 ,
    this.passengerNames = order.passengerNames // (string, optional): 乘车人姓名 ,
    this.payDate = order.payDate // (string): 支付时间 ,
    this.payDeptName = order.payDeptName // (string): 支付部门名称 ,
    this.payStatus = order.payStatus // (string): 支付状态 0未付 1已付 ,
    this.paySubjectName = order.paySubjectName // (string): 支付科目名称 ,
    this.payUserName = order.payUserName // (string): 支付人名称 ,
    this.priceDiff = order.priceDiff // (number): 票价差价 ,
    this.sentDeptName = order.sentDeptName // (string, optional): 送审人所在的部门 ,
    this.sentEmpNo = order.sentEmpNo // (string, optional): 送审人编号/名称 ,
    this.sentTime = order.sentTime // (string, optional): 送审时间 ,
    this.showCancelButton = order.showCancelButton // (string): 是否显示取消按钮 0否 1是 ,
    this.showConfirmButton = order.showConfirmButton // (string): 是否显示确定出票按钮 0否 1是 ,
    this.showPayButton = order.showPayButton // (string): 是否显示支付按钮 0否 1是 ,
    this.showRefundButton = order.showRefundButton // (string): 是否显示退票按钮 0否 1是 ,
    this.showSendCkButton = order.showSendCkButton // (string): 是否显示送审按钮 0否 1是 ,
    this.supplierName = order.supplierName // (string): 供应商名称 ,
    this.takeTicketCode = order.takeTicketCode // (string, optional): 取票单号（12306订单号） ,
    this.ticketNumber = order.ticketNumber // (integer): 订单id ,
    this.vipStatus = order.vipStatus // (string): 差旅状态
    this.psgList = order.psgList.map(psg => new Passenger(psg, order)) // (Array[ObtTrChangeOrderPsg]): 改签乘车人集合
    
    this.orderType = $dict.ORDER_TYPE.tr.change
  }
  
  // 是否是拒单
  get isReject () {
    return this.orderStatus === '7' && this.errMsg
  }
  
  // 支付方式
  get payMethodDesc () {
    if (this.payStatus === '1' && this.paySubjectName) {
      return `已使用${this.paySubjectName}支付`
    } else {
      return ''
    }
  }
  
  // 详细的订单描述
  get changeStatusDescDetail() {
    if (this.showPayButton === '1') {
      return '已为您锁定座位，建议尽快完成支付哦'
    } else if (this.showSendCkButton === '1') {
      return '正在为您占座中，您可先操作送审'
    } else {
      return '改签申请已提交，请等待服务商办理'
    }
  }
  
  // 展示审批规则
  get showApprovalRule () {
    return this.vipStatus !== '4'
  }
  
  get oldDetail () {
    return {
      fromDate: this.oldFromDate,
      fromTime: this.oldFromTime,
      toDate: this.oldToDate,
      toTime: this.oldToTime,
      travelTime: this.oldTravelTime,
      trainCode: this.oldTrainCode,
      fromStationName: this.oldFromStationName,
      fromStationCode: this.oldFromStationCode,
      toStationName: this.oldToStationName,
      toStationCode: this.oldToStationCode,
      trainNo: this.oldTrainNo
    }
  }

  get newDetail () {
    return {
      fromDate: this.newFromDate,
      fromTime: this.newFromTime,
      toDate: this.newToDate,
      toTime: this.newToTime,
      travelTime: this.newTravelTime,
      trainCode: this.newTrainCode,
      fromStationName: this.newFromStationName,
      fromStationCode: this.newFromStationCode,
      toStationName: this.newToStationName,
      toStationCode: this.newToStationCode,
      trainNo: this.newTrainNo
    }
  }
}